import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';

const renderColorIndication = (label: string, color: string) => {
  return (
    <div className="flex items-center">
      <span
        className={`inline-block w-3 h-3 rounded-sm mr-[2px]`}
        style={{ backgroundColor: color }}
      />
      <Typography variant="p5">{label}</Typography>
    </div>
  );
};

export default renderColorIndication;
